import type { SvgIconComponent } from '@mui/icons-material';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AllInclusiveIcon from '@mui/icons-material/AllInclusive';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';

import type { ProductId } from './types';

/** Icons aligned with ProgramProgressStepper program steps. */
export const PRODUCT_ICONS: Record<ProductId, SvgIconComponent> = {
  starter: AssessmentIcon,
  mid_program: MenuBookIcon,
  completion: TrendingUpIcon,
  full_access: AllInclusiveIcon,
};

export function getProductIcon(productId: ProductId): SvgIconComponent {
  return PRODUCT_ICONS[productId];
}
